module.exports = __webpack_public_path__ + "media/images/business/sd-timeline-mobile-fd00748cee578fa9074e46afde5fcb52.svg";